import React, {Component} from 'react';
import _ from 'lodash';
import classNames from 'classnames';

class DateSelectionTrayOption extends Component {
  constructor(props) {
    super(props);
    this.onOptionClick = this.onOptionClick.bind(this);
  }

  onOptionClick(e) {
    if(!this.enabled()) return;
    this.props.onClick(e);
  }

  renderDescription() {
    return (
      <div className="description">
        <div className="name">{this.props.name}</div>
        <div className="details">{this.renderDetails()}</div>
        {this.renderTimes()}
      </div>
    );
  }

  renderDetails() {
    if (this.enabled()){
      return this.props.details;
    } else {
      return this.props.disabledDetails;
    }
  }

  renderTimes() {
    const departuresSupplied = !Array.isArray(this.props.departures);
    const departures = _.compact(new Array(this.props.departures)).flat();
    const timesClass = classNames({
      times: true,
      invisible: (departuresSupplied || this.disabled()),
    });

    let departureText;
    if (departures.length < 4) {
      departureText = departures.join(', ');
    } else {
      departureText = `${departures.slice(0, 2).join(', ')}, and ${departures.length - 2} more`;
    }

    return (
      <div className={timesClass}>
          <span className="label label-default"
                style={{backgroundColor: '#0091A6', fontWeight: 'normal', whiteSpace: 'normal'}}>
            <i className="fa fa-clock-o" aria-hidden="true"></i>
            <span style={{marginLeft: '2px'}}>{departureText}</span>
          </span>
      </div>
    );
  }

  enabled() {
    return this.props.price || !this.disableable();
  }

  disabled(){
    return !this.enabled();
  }

  disableable() {
    return !!this.props.disabledDetails;
  }

  renderCol2() {
    if (this.disabled() && this.props.disabledCallToAction) {
      return this.props.disabledCallToAction;
    } else {
      this.renderPrice();
    }
  }

  renderPrice() {
    if (!this.props.price){
      return <div className="price"></div>;
    }

    return (
      <div className="price">
        <div className="qualifier">
          From
        </div>
        <div className="amount">
          {this.formatPrice()}
        </div>
        {this.renderPerSeat()}
      </div>
    );
  }

  renderPerSeat() {
    if (this.props.perSeat){
      return <div className="qualifier">per seat</div>;
    }
  }

  formatPrice() {
    return `${Flyblade.Utils.formatCurrency(this.props.price)}`;
  }

  render() {
    const divClass = classNames(this.props.className, {
      option: true,
      disabled: this.disabled(),
    });

    return (
      <div
        className={divClass}
        onClick={this.onOptionClick}
      >
        {this.renderDescription()}
        {this.renderCol2()}
      </div>
    );
  }
}

export default DateSelectionTrayOption;